(function () {
	const initSlider = () => {
		const slider = document.querySelector(".swiper-container");
		if (!slider || slider.classList.contains("slider_started")) {
			return;
		}
		slider.classList.add("slider_started");
		var swiper = new Swiper(".swiper-container", {
			slidesPerView: 1,
			speed: 250,
			spaceBetween: 0,
			navigation: {
				nextEl: ".product-button-group .swiper-button-next-1",
				prevEl: ".product-button-group .swiper-button-prev-1",
			},
			pagination: {
				el: " .product-card-pagination",
				clickable: true,
			},
		});

		const swiperInstances = Array.isArray(swiper) ? swiper : [swiper];
		swiperInstances.forEach((instance) => {
			const cardWrapper = instance.el.closest(".card-wrapper");
			if (!cardWrapper || instance.slides.length < 2) {
				return;
			}
			cardWrapper.addEventListener("mouseenter", () => instance.slideTo(1));
			cardWrapper.addEventListener("mouseleave", () => instance.slideTo(0));
		});
	};
	initSlider();
	document.addEventListener("shopify:section:load", function () {
		initSlider();
		document.addEventListener("shopify:section:load", function () {
			initSlider();
		});
	});
})();
